<form [formGroup]="form">
  <fieldset>
    <legend class="custom-legend">Informations générales</legend>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <label for="typeRecrutement" class="label col-6 col-form-label">Type de recrutement@if (this.form.get('typeRecrutement')?.hasValidator(ValidatorsRef.required)) {
            *
          }</label>
          <div class="form-text mb-1">Sélectionnez le type de recrutement (permanent , temporaire...).</div>
          <mat-form-field class="w-100">
            <input
              type="text"
              matInput
              aria-label="Type de recrutement"
              name="Type de recrutement"
              [matAutocomplete]="autoTypeRecrutement"
              formControlName="typeRecrutement"
              (input)="filterRecrutementList($event)"
              />

              <mat-autocomplete
                hideSingleSelectionIndicator
                requireSelection
                #autoTypeRecrutement="matAutocomplete"
                [displayWith]="typeRecrutementdisplayFn"
                >
                @for (type of recrutementListFiltered; track type) {
                  <mat-option [value]="type">
                    {{ type.libelle }}
                  </mat-option>
                }
              </mat-autocomplete>

              @if (form.get('typeRecrutement')?.hasError('required') && form.get('typeRecrutement')?.touched) {
                <mat-error>
                  Le type de recrutement est requis.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <mat-label for="pole" class="label col-6 col-form-label">Pole@if (this.form.get('pole')?.hasValidator(ValidatorsRef.required)) {
              *
            }</mat-label>
            <div class="form-text mb-1">Sélectionnez le pole (famille , attractivité et cohésion...).</div>
            <mat-form-field class="w-100">
              <input type="text" aria-label="Pole" matInput name="item" [matAutocomplete]="autoPole" formControlName="pole" />
              <mat-autocomplete #autoPole="matAutocomplete" hideSingleSelectionIndicator requireSelection [displayWith]="poledisplayFn">
                @for (pole of poleListFiltered; track pole) {
                  <mat-option [value]="pole"> {{ pole.libelle }} </mat-option>
                }
              </mat-autocomplete>
              @if (form.get('pole')?.hasError('required') && form.get('pole')?.touched) {
                <mat-error> Le pole est requis. </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="col-6">
          <label for="direction" class="label col-6 col-form-label">Direction@if (this.form.get('direction')?.hasValidator(ValidatorsRef.required)) {
            *
          }</label>
          <div class="form-text mb-1">Sélectionnez la direction.</div>
          <mat-form-field class="w-100">
            <input type="text" aria-label="Direction" matInput [matAutocomplete]="autoDirection" formControlName="direction" (input)="directionFilter($event)" />
            @if (form.get('direction')?.value && directionList.length > 1) {
              <button
                type="button"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="clearField($event, 'direction')"
                >
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-autocomplete cdkScrollable #autoDirection="matAutocomplete" [displayWith]="directiondisplayFn">
              @for (item of directionListFiltered; track item) {
                <mat-option [value]="item">{{ item.libelle }}</mat-option>
              }
            </mat-autocomplete>
            @if (form.get('direction')?.hasError('required') && form.get('direction')?.touched) {
              <mat-error>
                La direction est requise.
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-6">
          <label for="service" class="label col-6 col-form-label">Service ou unité de rattachement@if (this.form.get('service')?.hasValidator(ValidatorsRef.required)) {
            *
          }</label>
          <div class="form-text mb-1">Sélectionnez le service ou unité de rattachement.</div>
          <mat-form-field class="w-100">
            <input
              type="text"
              aria-label="Service"
              matInput
              [matAutocomplete]="autoService"
              formControlName="service"
              (input)="serviceFilter($event)"
              />
              @if (form.get('service')?.value) {
                <button
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearField($event, 'service')"
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
              <mat-autocomplete #autoService="matAutocomplete" hideSingleSelectionIndicator requireSelection [displayWith]="servicedisplayFn">
                @for (element of serviceFonctionnelListFiltered; track element) {
                  <mat-option [value]="element">{{ element.libelle }}</mat-option>
                }
              </mat-autocomplete>
              @if (form.get('service')?.hasError('required') && form.get('service')?.touched) {
                <mat-error> Le service est requis. </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-6">
            <label for="intituleposte" class="label col-6 col-form-label">Intitulé du poste@if (this.form.get('intituleposte')?.hasValidator(ValidatorsRef.required)) {
              *
            }</label>
            <div class="form-text mb-1">
              @if (!isLoadingPostes) {
                <span>Sélectionnez l'intitulé du poste.</span>
              }
              @if (isLoadingPostes) {
                <span>Chargement des postes...</span>
              }
            </div>
            <mat-form-field class="w-100">
              <input
                type="text"
                aria-label="intituleposte"
                matInput
                [matAutocomplete]="autoIntitulePoste"
                formControlName="intituleposte"
                (input)="IntitulePosteFilter($event)"
                />
                @if (form.get('intituleposte')?.value && !form.get('intituleposte')?.disabled && !isLoadingPostes) {
                  <button
                    type="button"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearField($event, 'intituleposte')"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
                @if (isLoadingPostes) {
                  <mat-icon matSuffix class="loading-spinner">refresh</mat-icon>
                }
                <mat-autocomplete
                  #autoIntitulePoste="matAutocomplete"
                  hideSingleSelectionIndicator
                  requireSelection
                  [displayWith]="IntitulePostedisplayFn"
                  >
                  @for (poste of posteListFiltered; track poste) {
                    <mat-option [value]="poste">{{ poste.libelle }} - {{ poste.code }}</mat-option>
                  }
                </mat-autocomplete>
                @if (form.get('intituleposte')?.hasError('required') && form.get('intituleposte')?.touched) {
                  <mat-error>
                    L'intitulé du poste est requis.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-6">
              <label for="numeroPoste" class="label col-6 col-form-label">Numéro de poste@if (this.form.get('numeroPoste')?.hasValidator(ValidatorsRef.required)) {
                *
              }</label>
              <div class="form-text mb-1">
                @if (!isLoadingPostes) {
                  <span>Sélectionnez le numéro de poste.</span>
                }
                @if (isLoadingPostes) {
                  <span>Chargement des postes...</span>
                }
              </div>
              <mat-form-field class="w-100">
                <input
                  type="text"
                  aria-label="Numéro de poste"
                  matInput
                  [matAutocomplete]="autoNumeroPoste"
                  formControlName="numeroPoste"
                  (input)="numeroPosteFilter($event)"
                  />
                  @if (form.get('numeroPoste')?.value && !form.get('numeroPoste')?.disabled && !isLoadingPostes) {
                    <button
                      type="button"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearField($event, 'numeroPoste')"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                  @if (isLoadingPostes) {
                    <mat-icon matSuffix class="loading-spinner">refresh</mat-icon>
                  }
                  <mat-autocomplete
                    #autoNumeroPoste="matAutocomplete"
                    hideSingleSelectionIndicator
                    requireSelection
                    [displayWith]="numeroPosteDisplayFn"
                    >
                    @for (poste of numeroPosteListFiltered; track poste) {
                      <mat-option [value]="poste">{{ poste.numero }}</mat-option>
                    }
                  </mat-autocomplete>
                  @if (form.get('numeroPoste')?.hasError('required') && form.get('numeroPoste')?.touched) {
                    <mat-error>
                      Le numéro de poste est requis.
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Warning message for post loading errors - spans full width under both post fields -->
              <!-- Only show for non-vacataire types -->
              @if (posteLoadError && !isVacataireType()) {
                <div class="col-12 mt-2">
                  <div class="alert alert-warning mb-2" style="display: flex;align-items: flex-end;" role="alert">
                    <mat-icon class="me-2">warning</mat-icon>
                    {{ posteLoadError }}
                  </div>
                </div>
              }
              <div class="col-6">
                <label for="motifLiberation" id="label-motifLiberation" class="label col-6 col-form-label">Motif de libération du poste@if (this.form.get('motifLiberation')?.hasValidator(ValidatorsRef.required)) {
                  *
                }</label>
                <div class="form-text mb-1">Sélectionnez un motif.</div>
                <mat-form-field class="w-100">
                  <input
                    type="text"
                    aria-label="motif liberation"
                    matInput
                    [matAutocomplete]="autoMotifLiberation"
                    formControlName="motifLiberation"
                    (input)="motifLiberationFilter($event)"
                    />

                    @if (form.get('motifLiberation')?.value) {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="effaceFilteMotifLiberation($event, 'motifLiberation')"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                    <mat-autocomplete cdkScrollable #autoMotifLiberation="matAutocomplete" [displayWith]="motifLiberationdisplayFn">
                      @for (motif of motifLiberationListFiltered; track motif) {
                        <mat-option [value]="motif"> {{ motif.libelle }}</mat-option>
                      }
                    </mat-autocomplete>
                    @if (form.get('motifLiberation')?.hasError('required') && form.get('motifLiberation')?.touched) {
                      <mat-error>
                        Le motif de libération est requis.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </fieldset>

            <div class="button-group">
              <button mat-stroked-button type="button" (click)="onReset()"><mat-icon>autorenew</mat-icon>Réinitialiser</button>
              <button mat-flat-button color="primary" type="submit" matStepperNext [disabled]="!form.valid">Suivant</button>
            </div>
          </form>
